import React from 'react';

interface MiniModalFooterProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export function MiniModalFooter({ left, right }: MiniModalFooterProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-1.5">{left}</div>
      <div className="flex items-center gap-1.5">{right}</div>
    </div>
  );
}

interface MiniIntegrationSourceButtonProps {
  iconSrc: string;
  label: string;
  target?: string;
}

export function MiniIntegrationSourceButton({ iconSrc, label, target }: MiniIntegrationSourceButtonProps) {
  return (
    <div
      data-cursor-target={target}
      title={label}
      className="flex items-center justify-center size-5 rounded-comfortable bg-surface-frost-05 hover:bg-surface-frost-08 transition-colors duration-300"
    >
      <img src={iconSrc} alt="" className="size-[9px] opacity-80" />
    </div>
  );
}

interface MiniComposeFieldProps {
  label: string;
  placeholder: string;
}

export function MiniComposeField({ label, placeholder }: MiniComposeFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[7px] text-text-quaternary">{label}</span>
      <div className="text-[8px] text-text-tertiary px-2 py-1.5 rounded-comfortable bg-surface-frost-03">
        {placeholder}
      </div>
    </div>
  );
}
